module.exports = __webpack_public_path__ + "y.no2.cb344523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/y.no2.jpg
// module id = L9iV
// module chunks = 0